import { DialogWrapper } from 'Dialogs/wrapper';
import html from './template.html';
import './style.less';

class UserClickAreasSidesheet extends DialogWrapper {
  constructor(params = {}, element) {
    super(params, element);

    this.question = params.question;
    this.answer = params.answer;
    this.noTitle = params.noTitle

    this.title = ko.observable(this.noTitle ? '' : params.title || 'Карта кликов пользователя');

    this.imageSrc = ko.observable(ko.unwrap(this.question?.imageSrc) || ko.unwrap(this.question?.imageUrl));
    this.imageWidth = ko.observable(ko.unwrap(this.question?.imageWidth) || null);
    this.imageHeight = ko.observable(ko.unwrap(this.question?.imageHeight) || null);
    
    this.clicksData = ko.computed(() => {
      if (!this.answer || !ko.unwrap(this.answer.click_points)) {
        return [];
      }

      return ko.unwrap(this.answer.click_points).map(click => ({
        x: click.x,
        y: click.y,
        areaName: click.label || `Область #${click.id}`,
				timeInSeconds: click.timeInSeconds >= 0 ? click.timeInSeconds : 0 || 'N/A'
      }));
    });

    this.showcaseSize = params.showcaseSize || undefined; 
  }

  onModalInit(...args) {
    super.onModalInit(...args);
  }
}

ko.components.register('user-click-areas-sidesheet', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      const element = componentInfo.element;
      element.classList.add('user-click-areas-sidesheet');
      return new UserClickAreasSidesheet(params, element);
    },
  },
  template: html,
});

export default UserClickAreasSidesheet;
